// src/services/pdf/data/fetchPWResponses.ts
// Fetches PW (Physical Wellbeing) video questionnaire answers from Firestore.
// These are the weekly questionnaire responses tied to the video content.
// Stored at: questionnaires/{uid}/video_responses/week_{n}

import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import type { PWQuestionnaireResponse } from "../types";

/**
 * Fetches all 6 weeks of PW video questionnaire responses for a user.
 * Returns only weeks that have submitted answers.
 */
export async function fetchPWResponses(uid: string): Promise<PWQuestionnaireResponse[]> {
  const weekIds = ["week_1", "week_2", "week_3", "week_4", "week_5", "week_6"];

  const snapshots = await Promise.all(
    weekIds.map((weekId) =>
      getDoc(doc(db, "questionnaires", uid, "video_responses", weekId))
    )
  );

  const responses: PWQuestionnaireResponse[] = [];

  for (let i = 0; i < snapshots.length; i++) {
    const snap = snapshots[i];
    if (snap.exists()) {
      const data = snap.data() as Record<string, string>;
      responses.push({
        weekId: weekIds[i],
        answers: data,
      });
    }
  }

  return responses;
}
